import axios from 'axios';
import { getCurrentJWTUser, logout } from '@/lib/auth';

const apiClient = axios.create({
  baseURL: '/api',
});

apiClient.interceptors.request.use((config) => {
  const user = getCurrentJWTUser();

  if (user) {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }

  return config;
});

apiClient.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    const hasStoredToken = Boolean(localStorage.getItem('token'));

    if (error?.response?.status === 401 && hasStoredToken) {
      logout();
      window.location.replace('/login');
    }

    return Promise.reject(error);
  }
);

export default apiClient;
